<template>
  <div class="content-wrapper">
    <section class="content-header">
      <div class="container-fluid">
        <div class="row mb-2">
          <div class="col-sm-6">
            <h1>CMS Pages</h1>
          </div>
          <div class="col-sm-6">
            <ol class="breadcrumb float-sm-right">
              <li class="breadcrumb-item">
                <router-link :to="{ name: 'Home' }">Home</router-link>
              </li>
              <li class="breadcrumb-item active">CMS Pages</li>
            </ol>
          </div>
        </div>
      </div>
    </section>

    <section class="content">
      <div class="container-fluid">
        <div class="card" id="CMSPage">
          <div class="overlay" v-if="is_loading">
            <i class="fas fa-2x fa-sync-alt fa-spin"></i>
          </div>
          <form @submit.prevent="handleSubmission()" method="POST" novalidate>
            <div class="card-header">
              <h3 class="card-title" v-if="!is_edit">Create</h3>
              <h3 class="card-title" v-if="is_edit">Edit</h3>
              <div class="card-tools">
                <router-link class="btn btn-info" :to="{ name: 'CMSPageList' }"
                  ><i class="fas fa-list"></i> List
                </router-link>
              </div>
            </div>
            <div class="card-body">
              <div class="row">
                <div class="col-8">
                  <el-tabs type="border-card" v-model="activeTabName">
                    <el-tab-pane
                      label="Page Information"
                      name="Page Information"
                    >
                      <div class="form-group required">
                        <label class="control-label">Page Title</label>
                        <input
                          type="text"
                          id="page_title"
                          name="page_title"
                          v-bind:class="{
                            'has-error': errors.has('page_title'),
                          }"
                          v-validate="'required'"
                          v-model="value.page_title"
                          class="form-control page_title"
                          placeholder="Page Title"
                        />
                        <div
                          class="help text-danger"
                          v-show="errors.has('page_title')"
                        >
                          {{ errors.first("page_title") }}
                        </div>
                      </div>
                      <div class="form-group required">
                        <label class="control-label">Slug</label>
                        <input
                          type="text"
                          id="slug_url"
                          name="slug_url"
                          v-bind:class="{ 'has-error': errors.has('slug_url') }"
                          v-validate="'required'"
                          v-model="value.slug_url"
                          class="form-control slug_url"
                          placeholder="Slug"
                        />
                        <div
                          class="help text-danger"
                          v-show="errors.has('slug_url')"
                        >
                          {{ errors.first("slug_url") }}
                        </div>
                      </div>
                      <div class="form-group">
                        <label class="control-label">Summery</label>
                        <textarea
                          id="summery"
                          name="summery"
                          v-model="value.summery"
                          class="form-control summery"
                          placeholder="Summery"
                          rows="3"
                        ></textarea>
                      </div>
                      <div class="form-group">
                        <label class="control-label">Content</label>
                        <ckeditor
                          value=""
                          name="page_content"
                          v-model="value.page_content"
                          class="page_content"
                          :config="editorConfig"
                        ></ckeditor>
                        <!--                        <textarea id="page_content" name="page_content"


                                                          v-model="value.page_content" class="form-control page_content"
                                                          placeholder="Content"
                                                          rows="3"></textarea>-->
                      </div>

                      <div class="col-md-12">
                        <h4 class="site-heading my-3">
                          <span>Featured Image</span>
                        </h4>
                      </div>
                      <div class="form-group col-md-12">
                        <label for="featured_image"></label>
                        <div class="row align-items-center">
                          <div class="col-12 col-md-4">
                            <div class="input-group">
                              <div class="custom-file">
                                <input
                                  type="file"
                                  name="featured_image"
                                  class="custom-file-input col-md-4 col-sm-12"
                                  id="featured_image"
                                  accept="image/png, image/jpeg, image/jpg"
                                  @change="select_file_featured_image"
                                />
                                <label
                                  class="custom-file-label"
                                  for="featured_image"
                                >
                                  {{ value.featured_image_name }}
                                </label>
                              </div>
                            </div>
                          </div>
                          <div class="form-group" v-if="featured_image_temp">
                            <img
                              alt="preview image"
                              :src="featured_image_temp"
                              width="100"
                              height="100"
                              class="img-circle"
                            />
                            {{ value.featured_image_name }}
                          </div>
                        </div>
                      </div>

                      <div class="form-group">
                        <label class="control-label">Page Template</label>
                        <multiselect
                          v-model="value.page_template"
                          :options="pre.page_template"
                        ></multiselect>

                        <div
                          class="help text-danger"
                          v-show="errors.has('page_template')"
                        >
                          {{ errors.first("page_template") }}
                        </div>

                        <!--                        <input type="text" id="page_template" name="page_template"
                                                       v-model="value.page_template" class="form-control page_template"
                                                       placeholder="Page Template">-->
                      </div>
                    </el-tab-pane>
                    <el-tab-pane label="SEO Settings" name="SEO Settings">
                      <div class="form-group">
                        <label class="control-label">SEO Title</label>
                        <input
                          type="text"
                          id="seo_title"
                          name="seo_title"
                          v-model="value.seo_title"
                          class="form-control seo_title"
                          placeholder="SEO Title"
                        />
                      </div>
                      <div class="form-group">
                        <label class="control-label">SEO Summery</label>
                        <textarea
                          id="seo_summery"
                          name="seo_summery"
                          v-model="value.seo_summery"
                          class="form-control seo_summery"
                          placeholder="SEO Summery"
                          rows="3"
                        ></textarea>
                      </div>
                      <div class="form-group">
                        <label class="control-label">SEO Keywords</label>
                        <textarea
                          id="seo_keywords"
                          name="seo_keywords"
                          v-model="value.seo_keywords"
                          class="form-control seo_keywords"
                          placeholder="SEO Keywords"
                          rows="3"
                        ></textarea>
                      </div>
                      <div class="col-md-12">
                        <h4 class="site-heading my-3">
                          <span>SEO Image</span>
                        </h4>
                      </div>
                      <div class="form-group col-md-12">
                        <label for="seo_image"></label>
                        <div class="row align-items-center">
                          <div class="col-12 col-md-4">
                            <div class="input-group">
                              <div class="custom-file">
                                <input
                                  type="file"
                                  name="seo_image"
                                  class="custom-file-input"
                                  id="seo_image"
                                  accept="image/png, image/jpeg, image/jpg"
                                  @change="select_file_seo_image"
                                />
                                <label
                                  class="custom-file-label"
                                  for="seo_image"
                                >
                                  {{ value.seo_image_name }}
                                </label>
                              </div>
                            </div>
                          </div>
                          <div class="form-group" v-if="seo_image_temp">
                            <img
                              alt="preview image"
                              :src="seo_image_temp"
                              width="100"
                              height="100"
                              class="img-circle"
                            />
                            <!--                            <i
                                                          class="fas fa-window-close"
                                                          @click="removeFile('image')"
                                                        ></i>-->
                          </div>
                        </div>
                      </div>
                    </el-tab-pane>
                    <el-tab-pane label="Custom Fields" name="Custom Fields">
                      <div
                        class=""
                        v-for="custom_field_detail in custom_field_value.cms_custom_field_details"
                      >
                        <div
                          class="col-md-12 separator-border"
                          v-if="custom_field_detail.field_type === 'Text'"
                        >
                          <div class="custom_field_title">
                            <strong>{{
                              custom_field_detail.field_label
                            }}</strong>
                          </div>
                          <div class="col-md-12">
                            <div class="form-horizontal">
                              <div class="form-group row">
                                <label class="col-md-2 control-label">{{
                                  custom_field_detail.fields_extras.field_label
                                }}</label>
                                <div class="col-md-10">
                                  <input
                                    required=""
                                    type="text"
                                    v-model="
                                      value.extra_contents[
                                        custom_field_detail.field_label
                                      ][
                                        custom_field_detail.fields_extras
                                          .field_name
                                      ]
                                    "
                                    name="value[custom_field_detail.field_label][custom_field_detail.fields_extras.field_name]"
                                    class="form-control"
                                  />
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div
                          class="col-md-12 separator-border"
                          v-if="custom_field_detail.field_type === 'Textarea'"
                        >
                          <div class="custom_field_title">
                            <strong>{{
                              custom_field_detail.field_label
                            }}</strong>
                          </div>
                          <div class="col-md-12">
                            <div class="form-horizontal">
                              <div class="form-group row">
                                <label class="col-md-2 control-label">{{
                                  custom_field_detail.fields_extras.field_label
                                }}</label>
                                <div class="col-md-10">
                                  <textarea
                                    required=""
                                    type="text"
                                    v-model="
                                      value.extra_contents[
                                        custom_field_detail.field_label
                                      ][
                                        custom_field_detail.fields_extras
                                          .field_name
                                      ]
                                    "
                                    class="form-control"
                                  ></textarea>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>

                        <div
                          class="col-md-12 separator-border"
                          v-if="custom_field_detail.field_type === 'Repeater'"
                        >
                          <div class="col-md-12">
                            <strong>{{
                              custom_field_detail.field_label
                            }}</strong>
                            <div class="col-md-12">
                              <div class="form-horizontal">
                                <div
                                  class="separator-border"
                                  v-for="(repeated_fields, key) in value
                                    .extra_contents[
                                    custom_field_detail.field_label
                                  ]"
                                >
                                  <div
                                    class=""
                                    v-for="field_extras in custom_field_detail.fields_extras_additional"
                                  >
                                    <div
                                      class="form-group"
                                      v-if="field_extras.field_type === 'Text'"
                                    >
                                      <label class="col-md-2 control-label">{{
                                        field_extras.field_label
                                      }}</label>
                                      <div class="col-md-10">
                                        <input
                                          required=""
                                          type="text"
                                          name=""
                                          v-model="
                                            value.extra_contents[
                                              custom_field_detail.field_label
                                            ][key][field_extras.field_name]
                                          "
                                          class="form-control"
                                        />
                                      </div>
                                    </div>
                                    <div
                                      class="form-group"
                                      v-if="
                                        field_extras.field_type === 'Textarea'
                                      "
                                    >
                                      <label class="col-md-2 control-label">{{
                                        field_extras.field_label
                                      }}</label>
                                      <div class="col-md-10">
                                        <textarea
                                          required=""
                                          v-model="
                                            value.extra_contents[
                                              custom_field_detail.field_label
                                            ][key][field_extras.field_name]
                                          "
                                          type="text"
                                          class="form-control"
                                          rows="5"
                                        ></textarea>
                                      </div>
                                    </div>
                                  </div>
                                  <div class="col-md-12">
                                    <a
                                      class="btn btn-danger btn-xs"
                                      @click="
                                        remove_more_fields(
                                          custom_field_detail.field_label,
                                          key
                                        )
                                      "
                                      >Remove</a
                                    >
                                  </div>
                                </div>
                              </div>
                              <div class="col-md-12 p-lg-4">
                                <a
                                  class="btn btn-info btn-xs float-right"
                                  @click="
                                    add_more_fields(
                                      custom_field_detail.field_label
                                    )
                                  "
                                  >Add More +</a
                                >
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </el-tab-pane>
                  </el-tabs>
                </div>
              </div>
            </div>
            <!--            <span><pre>{{ pre.page_template }}</pre></span>-->
            <!--                        <span><pre>{{ value }}</pre></span>-->
            <div class="card-footer">
              <button type="submit" v-if="!is_edit" class="btn btn-primary">
                Submit
              </button>
              <button type="submit" v-if="is_edit" class="btn btn-primary">
                Update
              </button>
            </div>
          </form>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
//import MasterLayout from "@/components/layouts/MasterLayoutComponent";
import { DepartmentsAPI, CommonAPI } from "@/services/api";
import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";
import axios from "axios";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";

export default {
  name: "CMSPageForm",
  metaInfo: {
    title: "CMS Pages | Dotlines",
  },
  components: {
    DatePicker,
  },
  data: () => ({
    isSelectorLoading: false,
    is_loading: false,
    is_edit: false,
    params: {},
    activeTabName: "Page Information",
    value: {
      featured_image: "",
      featured_image_name: "Choose file",
      seo_image: "",
      seo_image_name: "Choose file",
      extra_contents: [],
    },
    featured_image_temp: "",
    seo_image_temp: "",
    custom_field_value: {},
    extra_contents: {},
    pre: {
      page_template: [],
    },
    editor: ClassicEditor,
    editorConfig: {
      allowedContent: true,
      //fullPage: true
    },
  }),
  methods: {
    add_more_fields: function (variable) {
      this.value.extra_contents[variable].push({});
    },
    remove_more_fields: function (variable, index) {
      this.value.extra_contents[variable].splice(index, 1);
      //this.value.fields_extras.splice(index, 1)
    },
    removeFile: function () {
      this.value.featured_image = null;
      this.value.featured_image_name = null;
    },
    cmsPageTemplateOptions: function () {
      return new Promise((resolve, reject) => {
        axios
          .get("/cms_pages/page_templates")
          .then((response) => {
            resolve(response);
            //return response.data;
          })
          .catch((error) => {
            //console.log("error " + error);
            reject(error);
          });
      });
    },
    select_file_featured_image: function (event) {
      try {
        let readerFeatured = new FileReader();
        readerFeatured.readAsDataURL(event.target.files[0]);
        readerFeatured.onload = () => {
          this.featured_image_temp = readerFeatured.result;
          this.value.featured_image = readerFeatured.result;
          this.value.featured_image_name = event.target.files[0].name;
          //console.log(this.value);
        };
      } catch (e) {
        console.log(e);
      }
    },

    select_file_seo_image: function (event) {
      try {
        let reader = new FileReader();
        reader.readAsDataURL(event.target.files[0]);
        reader.onload = () => {
          this.seo_image_temp = reader.result;
          this.value.seo_image = reader.result;
          this.value.seo_image_name = event.target.files[0].name;
          //this.$set(this.value, "seo_image_name", event.target.files[0].name);
        };
      } catch (e) {
        //console.log(e);
      }
    },

    handleSubmission() {
      let _this = this;
      this.$validator.validateAll().then((result) => {
        if (result) {
          _this.is_loading = true;
          let api_url = "/cms_pages";
          let method = "POST";
          if (_this.is_edit) {
            api_url = "/cms_pages/" + _this.$route.params.id;
            method = "PUT";
          }
          console.log(this.value);
          axios({
            method: method,
            url: api_url,
            data: _this.value,
            headers: { "Content-Type": "application/json" },
          })
            .then(function (response) {
              _this.$toaster.success(response.data.message);
              _this.$router.push({ name: "CMSPageList" });
            })
            .catch((errors) => {
              if (errors.response.status === 500) {
                _this.$toaster.error(errors.response.data.message);
              }
              _this.$setErrorsFromResponse(errors.response.data);
            })
            .finally(() => {
              _this.is_loading = false;
            });
        }
      });
    },
    getDetail: function (id) {
      return new Promise((resolve, reject) => {
        let api_url = "/cms_pages/" + id;
        axios
          .get(api_url)
          .then((response) => {
            resolve(response);
          })
          .catch((error) => {
            //console.log("error " + error);
            reject(error);
          });
      });
    },
    getCustomFieldDetail: function (id) {
      return new Promise((resolve, reject) => {
        let api_url = "/cms_pages/custom_fields/" + id;
        axios
          .get(api_url)
          .then((response) => {
            resolve(response);
          })
          .catch((error) => {
            //console.log("error " + error);
            reject(error);
          });
      });
    },
    async initialize() {
      this.is_loading = true;
      this.params = this.$route.params;

      if (!_.isEmpty(this.params) && this.params.id !== undefined) {
        this.is_edit = true;
      }
      if (this.is_edit) {
        await this.cmsPageTemplateOptions()
          .then((response) => {
            this.pre.page_template = response.data;
          })
          .catch((error) => {
            console.log(error.response);
          });

        await this.getDetail(this.params.id)
          .then((response) => {
            this.value = response.data;
            //this.value.featured_image_name = "";
            if (response.data.featured_image) {
              var filename = response.data.featured_image.split("images/");
              this.featured_image_temp =
                this.API_ASSET_UPLOAD_URL + response.data.featured_image;
              this.value.featured_image_name =
                filename.length > 0 ? filename[1] : "";
            }
            if (response.data.seo_image) {
              var seo_image = response.data.seo_image.split("images/");
              this.seo_image_temp =
                this.API_ASSET_UPLOAD_URL + response.data.seo_image;
              this.value.seo_image_name =
                seo_image.length > 0 ? seo_image[1] : "";
            }
          })
          .catch((error) => {
            console.log(error.response);
          });

        await this.getCustomFieldDetail(this.params.id)
          .then((response) => {
            this.custom_field_value = response.data;

            //console.log('this.custom_field_value::', this.custom_field_value);

            if (!_.isEmpty(this.value.extra_contents)) {
              //this.value.extra_contents = {}
              this.custom_field_value.cms_custom_field_details.forEach(
                (fields) => {
                  if (
                    fields.field_type === "Text" ||
                    fields.field_type === "Textarea"
                  ) {
                    if (!_.has(this.value.extra_contents, fields.field_label)) {
                      this.$set(
                        this.value.extra_contents,
                        fields.field_label,
                        {}
                      );
                      this.$set(
                        this.value.extra_contents[fields.field_label],
                        fields.fields_extras.field_name,
                        ""
                      );
                    }
                  } else if (fields.field_type === "Repeater") {
                    if (!_.has(this.value.extra_contents, fields.field_label)) {
                      this.$set(this.value.extra_contents, fields.field_label, [
                        {},
                      ]);
                      this.$set(this.extra_contents, fields.field_label, []);
                    }
                  }
                }
              );
            } else {
              this.value.extra_contents = {};
              this.custom_field_value.cms_custom_field_details.forEach(
                (fields) => {
                  if (
                    fields.field_type === "Text" ||
                    fields.field_type === "Textarea"
                  ) {
                    this.$set(
                      this.value.extra_contents,
                      fields.field_label,
                      {}
                    );
                    this.$set(
                      this.value.extra_contents[fields.field_label],
                      fields.fields_extras.field_name,
                      ""
                    );
                  } else if (fields.field_type === "Repeater") {
                    this.$set(this.value.extra_contents, fields.field_label, [
                      {},
                    ]);
                    this.$set(this.extra_contents, fields.field_label, []);
                  }
                }
              );
            }
          })
          .catch((error) => {
            console.log(error.response);
          });

        //this.value.featured_image = "";
        this.value.seo_image = "";
      }

      this.is_loading = false;
    },
  },
  mounted() {
    this.initialize();
  },
  /*created() {
    this.$emit("update:layout", MasterLayout);
  },*/
};
</script>
<style scoped>
hr.dashed {
  border-top: 3px dashed #bbb;
}

.separator-border {
  border: 1px dashed #bbb;
  height: auto;
  padding: 10px;
  margin: 5px;
}

.custom_field_title {
  margin: 0 0 10px 0;
}
</style>
